import { CarGurusAdsSlice } from 'types/State';
import { createAction, createReducer, combineReducers } from '@reduxjs/toolkit';
import * as carGurusAds from 'lib/CarGurusAds';
import CGAdConfig from 'types/CarGurusAdConfig';

const adConfigReceived = createAction<{
  adUnit: string;
  adTargeting: carGurusAds.Targeting;
}>('carGurusAds/adConfigReceived');

const adConfigUnloaded = createAction('carGurusAds/adConfigUnloaded');

const clearTargetingEnqueued = createAction('carGurusAds/clearTargetingEnqueued');

const setPageTargetingEnqueued = createAction<carGurusAds.Targeting>(
  'carGurusAds/setPageTargetingEnqueued'
);

const enableServiceEnqueued = createAction('carGurusAds/enableServiceEnqueued');

const adComponentReadyToLoad = createAction<CGAdConfig>('carGurusAds/adComponentsReadyToLoad');

const adComponentTearingdown = createAction<CGAdConfig>('carGurusAds/adComponentTearingdown');

const slotDefinitionEnqueued = createAction<any>('carGurusAd/slotDefinitionEnqueued');

const slotDisplayEnqueued = createAction<any>('carGurusAd/slotDisplayEnqueued');

const slotDestructionEnqueued = createAction<Partial<CGAdConfig>>(
  'carGurusAd/slotDestructionEnqueued'
);

const adUnitReducer = createReducer<string | null>(null, {
  [adConfigReceived.type]: (_state, action) => {
    return action.payload.adUnit;
  },
});

const targetingReducer = createReducer<carGurusAds.Targeting>(
  {},
  {
    [adConfigReceived.type]: (state, action) => {
      return action.payload.adTargeting;
    },
    [adConfigUnloaded.type]: () => {
      return {};
    },
  }
);

const carGurusAdsReducer = combineReducers<CarGurusAdsSlice>({
  adUnit: adUnitReducer,
  targeting: targetingReducer,
});

export {
  adConfigReceived,
  adConfigUnloaded,
  clearTargetingEnqueued,
  setPageTargetingEnqueued,
  enableServiceEnqueued,
  slotDefinitionEnqueued,
  slotDisplayEnqueued,
  slotDestructionEnqueued,
  adComponentReadyToLoad,
  adComponentTearingdown,
  carGurusAdsReducer,
};
